{#if tag === 'svg'}
  <svg
    bind:this={element}
    use:useActions={use}
    use:forwardEvents
    {...$$restProps}><slot /></svg
  >
{:else if selfClosing}
  <svelte:element
    this={tag}
    bind:this={element}
    use:useActions={use}
    use:forwardEvents
    {...$$restProps}
  />
{:else}
  <svelte:element
    this={tag}
    bind:this={element}
    use:useActions={use}
    use:forwardEvents
    {...$$restProps}><slot /></svelte:element
  >
{/if}

<script>// @ts-ignore Need to use internal Svelte function
import { get_current_component } from 'svelte/internal';
import { forwardEventsBuilder, useActions } from './internal/index.js';
// Remember to update $$Props if you add/remove/rename props.
export let use = [];
export let tag;
const forwardEvents = forwardEventsBuilder(get_current_component());
$: selfClosing =
    [
        'area',
        'base',
        'br',
        'col',
        'embed',
        'hr',
        'img',
        'input',
        'link',
        'meta',
        'param',
        'source',
        'track',
        'wbr',
    ].indexOf(tag) > -1;
let element;
export function getElement() {
    return element;
}
</script>
